var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#F0F3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 19.4993V8.66602C5.33337 8.00297 5.59677 7.36709 6.06561 6.89825C6.53445 6.42941 7.17033 6.16602 7.83337 6.16602H16.1667C16.8297 6.16602 17.4656 6.42941 17.9345 6.89825C18.4033 7.36709 18.6667 8.00297 18.6667 8.66602V13.666C18.6667 14.3291 18.4033 14.9649 17.9345 15.4338C17.4656 15.9026 16.8297 16.166 16.1667 16.166H8.66671L5.33337 19.4993Z",
    stroke: "#AFB7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 9.5H15.3333",
    stroke: "#AFB7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 12.834H13.6666",
    stroke: "#AFB7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGray);
export default __webpack_public_path__ + "static/media/message-gray.539897d6b035f150563e143c94e0f8ea.svg";
export { ForwardRef as ReactComponent };